import { render, staticRenderFns } from "./PositionDirectiveSelector.vue?vue&type=template&id=0a208297&"
import script from "./PositionDirectiveSelector.vue?vue&type=script&lang=js&"
export * from "./PositionDirectiveSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports